module.exports = __webpack_public_path__ + "files/06a168e4ce5f73d924880cf9d67992a8.png";